import { render } from "./followProgress.vue?vue&type=template&id=0f4e3fc2&scoped=true"
import script from "./followProgress.vue?vue&type=script&lang=js"
export * from "./followProgress.vue?vue&type=script&lang=js"

import "./followProgress.vue?vue&type=style&index=0&id=0f4e3fc2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0f4e3fc2"

export default script